import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import { palette } from 'styles/color';

type TOCItem = {
  id: string;
  text: string;
  level: number;
};

interface TOCProps {
  items: TOCItem[];
}

export const Toc: React.FC<TOCProps> = ({ items }) => {
  const [activeId, setActiveId] = useState<string | null>(null);
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    const handleIntersect: IntersectionObserverCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveId(entry.target.id);
        }
      });
    };

    observerRef.current = new IntersectionObserver(handleIntersect, {
      rootMargin: '0px 0px -70% 0px', // 요소가 뷰포트 상단 30% 지점에 닿으면 활성화하기
      threshold: 0.1
    });

    const observer = observerRef.current;
    const targets = items
      .map((item) => document.getElementById(item.id))
      .filter(Boolean) as HTMLElement[];

    targets.forEach((target) => observer.observe(target));

    return () => {
      targets.forEach((target) => observer.unobserve(target));
    };
  }, [items]);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    // e.preventDefault();
    const targetElement = document.getElementById(id);

    // console.log(items);
    // console.log(targetElement, id);
    // debugger;

    if (!targetElement) {
      alert(`Element with id "${id}" not found.`);
      return;
    }

    targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // setActiveId(id); // 스크롤 후 intersectionObserver가 처리해줌

    setActiveId(id);

    window.history.pushState(null, '', `#${id}`);
  };

  return (
    <TOCContainer>
      <TOCList>
        {items.map((item) => (
          <TOCListItem key={item.id} $level={item.level} $active={activeId === item.id}>
            <a href={`#${item.id}`} onClick={(e) => handleClick(e, item.id)}>
              {item.text}
            </a>
          </TOCListItem>
        ))}
      </TOCList>
    </TOCContainer>
  );
};

const TOCContainer = styled.nav`
  width: 300px;
  height: fit-content;
  background: white;
  border: 1px solid ${palette.gray[200]};
  border-radius: 8px;
  padding: 30px;

  display: flex;
  flex-direction: column;
`;

const TOCList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const TOCListItem = styled.li<{ $level: number; $active: boolean }>`
  a {
    display: block;
    box-sizing: border-box;
    color: ${({ $active }) => ($active ? palette.blue[500] : palette.gray[500])};
    font-weight: ${({ $active }) => ($active ? 700 : 600)};
    font-size: 16px;
    line-height: 20px;
    text-indent: ${({ $level }) => ($level === 4 ? '20px' : '0')};
    transition: all 0.2s ease;
    cursor: pointer;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
